import React, { useState } from 'react';
import { Easing, TouchableOpacity } from 'react-native';
import { View } from '@shared/components/View';
import { MBAnimation } from '@shared/components/animation';
import { MBIconV2 } from '@shared/components/image';
import { Colors, grid } from '@shared/styles';

interface PullButtonProps {
  renderSelected: () => React.ReactNode;
  renderOptions: (onSelect: () => void) => React.ReactNode;
  onOpenChange?: (isOpen: boolean) => void;
  isMultiSelect?: boolean;
}

export function PullButton({
  renderSelected,
  renderOptions,
  onOpenChange,
  isMultiSelect = false,
}: PullButtonProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    const newIsExpanded = !isExpanded;
    setIsExpanded(newIsExpanded);
    onOpenChange?.(newIsExpanded);
  };

  const handleSelect = () => {
    if (!isMultiSelect) {
      setIsExpanded(false);
      onOpenChange?.(false);
    }
    // In multi-select mode, menu stays open - don't call onOpenChange
  };

  return (
    <View>
      <TouchableOpacity onPress={handleToggle}>
        <View
          row
          flex
          centerVertically
          paddingVertical={1.5}
          style={{ justifyContent: 'space-between' }}
        >
          <View row flex centerVertically style={{ maxWidth: '90%', overflow: 'hidden' }}>
            {renderSelected()}
          </View>
          <MBAnimation
            duration={200}
            easing={Easing.inOut(Easing.quad)}
            disabled={!isExpanded}
            rotate={{ from: '0deg', to: '90deg' }}
          >
            <MBIconV2 color={Colors.v2.purple} name="arrow-point-right" size={grid(3)} />
          </MBAnimation>
        </View>
      </TouchableOpacity>
      {isExpanded && renderOptions(handleSelect)}
    </View>
  );
}
